<template>
  <li v-show="teachersInKlassSameTime.length > 0">
    <label class="d-label">
      <span class="icon-users"></span>
      {{
        $t('vue2.substitution.lessons_that_overlap_in_class')
      }}
    </label>
    <ul>
      <li class="small-lesson"
          v-for="(userAndLesson, key) in teachersInKlassSameTime"
          :key="userAndLesson.user.user_calendar_id"
          :class="{'user--is-absent': userAndLesson.user.v_overlapping_absence.length > 0}"
          :content="userAndLesson.user.v_overlapping_absence.length < 1 ? userAndLesson.lesson.v_title : userAndLesson.user.v_overlapping_absence"
          v-if="isShowAllTeachers || key < numberOfTeachersToShow"
          v-tippy="{
                    arrow: true,
                    placement: 'left',
                    boundary: 'window',
                    zIndex: 2147483010
                  }"
          :style="{'border-left-color': userAndLesson.lesson.color}">
        <span class="icon-users" v-if="userAndLesson.user.v_is_substitute"></span>
        {{ userAndLesson.user.name }}
      </li>
      <li class="text-link"
          v-if="teachersInKlassSameTime.length > numberOfTeachersToShow"
          @click="isShowAllTeachers = !isShowAllTeachers">
        <template v-if="!isShowAllTeachers">
          {{ $t('vue2.common.show_more') }} ({{ numberOfTeachersHidden }})
        </template>
        <template v-else>
          {{ $t('vue2.common.show_less') }}
        </template>
      </li>
    </ul>
  </li>
</template>

<script>
import Moment from 'moment'
import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)
export default {
  props: {
    lesson: {
      type: Object
    }
  },
  data () {
    return {
      numberOfTeachersToShow: 3,
      isShowAllTeachers: false
    }
  },
  computed: {
    numberOfTeachersHidden () {
      return this.teachersInKlassSameTime.length - this.numberOfTeachersToShow
    },
    calsAndEventIds () {
      return this.$store.state.subs.allCalsWithEventIdsInHash
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    allUsersAndEvents () {
      return this.$store.state.subs.allUsersAndEvents
    },
    lessonThatOverLap () {
      return this.otherLessonsInKlassThatOverlap(this.lesson)
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    lessons () {
      return this.lessonThatOverLap.map(lesson => {
        return {
          ...lesson,
          v_title: lesson.title + ', ' + moment(lesson.start).format('LT') + '-' + moment(lesson.end).format('LT')
        }
      })
    },
    teachersInKlassSameTime () {
      const users = []
      this.lessons.forEach(lesson => {
        const usersOnLesson = lesson.calendar_events.filter(cal => cal.calendar_type === 'user')
        usersOnLesson.forEach(userCalEvent => {
          const user = this.allUsersAndEvents[userCalEvent.calendar_id]
          user['v_overlapping_absence'] = user.dayAbsence.length > 0 ? this.absenceOverlapLesson(lesson.id, user.dayAbsence) : []
          user['v_is_substitute'] = userCalEvent['substitute']
          const obj = {
            lesson: lesson,
            user: user
          }
          users.push(obj)
        })
      })
      return users
    }
  },
  methods: {
    otherLessonsInKlassThatOverlap (lesson) {
      const klassCals = lesson.calendar_events.filter(cal => cal.calendar_type === 'klass')
      // Extract all lessons from 'klass' calendars
      let klassCalEventsIDs = klassCals.map(cal => this.calsAndEventIds[cal.calendar_id])
      let allEventsInKlass = klassCalEventsIDs.map(obj => obj.lessons)
      let lessonsInKlass = allEventsInKlass[0] ? allEventsInKlass[0].map(id => this.allEventsInAHash[id]) : []

      let overlappingEvents = []
      lessonsInKlass.forEach(event => {
        const range1 = moment.range(lesson.start, lesson.end)
        const range2 = moment.range(event.start, event.end)

        if (event.id !== lesson.id && range1.overlaps(range2)) {
          overlappingEvents.push(event)
        }
      })
      return overlappingEvents
    },
    absenceOverlapLesson (lessonId, absenceIds) {
      const absenceOverlapping = []
      const absenceEvents = absenceIds.map(eventId => this.allEventsInAHash[eventId])
      const lessonEvent = this.allEventsInAHash[lessonId]
      absenceEvents.forEach(absenceEvent => {
        const range1 = moment.range(absenceEvent.start, absenceEvent.end)
        const range2 = moment.range(lessonEvent.start, lessonEvent.end)
        if (range1.intersect(range2)) {
          const absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT')
          absenceOverlapping.push(absentLessonReadable)
        }
      })
      return absenceOverlapping
    }
  }
}
</script>

<style scoped>
.small-lesson {
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 1px 2px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  padding: 2px 4px;
  margin-top: 3px;
}

.user--is-absent {
  color: #FA565AFF;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// LessonOverlapInKlass.vue?528b4cd7